import React from 'react';
import { Filter as FilterAdmin, TextInput, SelectInput } from 'react-admin';

import {
  NIVEL_CODIGO_NCM_CAPITULO,
  NIVEL_CODIGO_NCM_POSICAO,
  NIVEL_CODIGO_NCM_SUB_POSICAO_1,
  NIVEL_CODIGO_NCM_SUB_POSICAO_2,
  NIVEL_CODIGO_NCM_ITEM,
  NIVEL_CODIGO_NCM_SUB_ITEM,
} from '../../utils';

const choices = [
  { id: NIVEL_CODIGO_NCM_CAPITULO, name: 'Capítulo' },
  { id: NIVEL_CODIGO_NCM_POSICAO, name: 'Posição' },
  { id: NIVEL_CODIGO_NCM_SUB_POSICAO_1, name: 'Subposição 1' },
  { id: NIVEL_CODIGO_NCM_SUB_POSICAO_2, name: 'Subposição 2' },
  { id: NIVEL_CODIGO_NCM_ITEM, name: 'Item' },
  { id: NIVEL_CODIGO_NCM_SUB_ITEM, name: 'SubItem' },
];

const Filter = (props) => (
  <FilterAdmin {...props}>
    <TextInput label="Descrição" source="descricao" />
    <TextInput label="Código" source="codigo" />
    <TextInput label="Código Pai" source="codigo_pai" />
    <SelectInput
      sortable={false}
      source="nivel"
      label="Nível"
      choices={choices}
    />
  </FilterAdmin>
);

export default Filter;
